export default function PrivacyPolicy() {
  return (
    <main className="max-w-4xl mx-auto px-6 py-40">
      <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>

      <p className="mb-6 text-gray-700">
        Last updated: June 2026
      </p>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">Overview</h2>
        <p>
          MotoLog is designed to help users track motorcycle maintenance and
          service history. We value your privacy and aim to collect as little
          information as possible.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">Data Collection</h2>
        <p>
          MotoLog does not collect, store, transmit, or share any personal
          information.
        </p>
        <p className="mt-3">
          All maintenance records, mileage information, and other data entered
          into the application are stored locally on your device.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">Internet Access</h2>
        <p>
          MotoLog does not require an internet connection to function and does
          not transmit user data to any server.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">Third-Party Services</h2>
        <p>
          MotoLog does not use advertising networks, analytics platforms, or
          third-party services that collect user information.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">Data Security</h2>
        <p>
          Since all information remains on your device, you are responsible for
          maintaining backups and protecting access to your device.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">Children's Privacy</h2>
        <p>
          MotoLog does not knowingly collect information from children or any
          other users.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">
          Changes to This Privacy Policy
        </h2>
        <p>
          This Privacy Policy may be updated from time to time. Any changes will
          be posted on this page with an updated revision date.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-3">Contact</h2>
        <p>
          If you have any questions about this Privacy Policy, you can contact:
        </p>
        <p className="mt-2">
          Email: cherubini.franco@hotmail.com
        </p>
      </section>
    </main>
  );
}